import React from 'react';
import PropTypes from 'prop-types';
//import { Input } from '@progress/kendo-react-inputs';
import Input from '../components/Input'
import "@progress/kendo-theme-material/dist/all.css";

import FormSection from '../components/FormSection';
import FormItem from '../components/FormItem';
import isPage from '../hoc/isPage';
import Toolbar from "../components/Toolbar";
import ToolbarOption from '../components/ToolbarOption';
import { isEmpty } from '../helpers';
import DropDownContainer from '../components/DropDownContainer';
import { orgTypes } from '../constants';

class AdminEditOrgPage extends React.Component {
    static propTypes = {
        org: PropTypes.shape({
            orgID: PropTypes.number,
            orgName: PropTypes.string
        }),
        handleCloseModal: PropTypes.func,
        handleRefreshListing: PropTypes.func

    }
    state = {
        orgName: '',
        orgType: null,
        country: null,
        vendor: null,
        parentOrgs: [], // an array
        inactive: false,
        address1: '',
        address2: '',
        city: '',
        state: null,
        postalZip: '',
        phone: '',
        email: '',
        fax: '',
        website: '',
        contactInfo: '',
        timeZoneName: '',
        language: null,
        currency: null,
        notes: '',
        orgNumber: '',
        orgCode: '',

        // flag that gets raised once we have *created* (not updated) an org
        hasCreatedOrg: false,
        allowEditSuggestedOrders: false
    }

    // fake data
    // state = {
    //     orgName: "Test Org",
    //     orgType: {
    //         orgTypeID: 4,
    //         orgType: "Dealer",

    //     },
    //     country: {
    //         countryID: 1,
    //         countryName: "Canada"
    //     },
    //     vendor: null,
    //     parentOrgs: [{ "orgID": 43, "orgType": "Manufacturer", "country": "Australia", "hasChildren": true, "inactive": false, "orgName": "Harley-Davidson Australia/New Zealand" }, { "orgID": 66, "orgType": "Manufacturer", "country": "India", "hasChildren": true, "inactive": false, "orgName": "Harley-Davidson India" }], // an array
    //     inactive: false,
    //     address1: "887 Great Northern Way",
    //     address2: null,
    //     city: "Vancouver",
    //     state: {
    //         stateID: 2,
    //         stateName: "British Columbia"
    //     },
    //     postalZip: "V5H0G4",
    //     phone: "+16042990698",
    //     email: "ttchuah@gmail.com",
    //     fax: "+15328930892",
    //     website: "https://www.stackoverflow.com/",
    //     contactInfo: "Ask for Bob",
    //     timeZoneName: "Greenwich Meridian Time",
    //     language: {
    //         languageID: 1,
    //         languageName: "English"
    //     },
    //     currency: {
    //         currencyID: 1,
    //         currencyName: "Canadian Dollar"
    //     },
    //     notes: "These are my notes",
    //     orgNumber: "12392",



    componentDidMount() {
        // are we editing an existing org? if so, then get the data for this org.

        const { org } = this.props;
        if (org) {
            this.props.getData(`/api/portal/admin/org/${org.orgID}/GetOrg`).then(({ data }) => {

                this.setState({
                    orgName: data.orgName,
                    orgType: data.orgType,
                    orgCode: data.orgCode,
                    // orgType: {
                    //     orgTypeID: 3,
                    //     orgType: "DealerGroup"
                    // },
                    country: data.country,
                    vendor: data.vendor,
                    parentOrgs: data.parentOrgs, // an array
                    inactive: data.inactive,
                    address1: data.address1,
                    address2: data.address2,
                    city: data.city,
                    state: data.state,
                    postalZip: data.postalZIP,
                    phone: data.phone,
                    email: data.email,
                    fax: data.fax,
                    website: data.website,
                    contactInfo: data.contactInfo,
                    timeZoneName: data.timeZoneName,
                    language: data.language,
                    currency: data.currency,
                    notes: data.notes,
                    orgNumber: data.orgNumber,

                    // flag that gets raised once we have *created* (not updated) an org
                    hasCreatedOrg: false,
                    allowEditSuggestedOrders: data.allowEditSuggestedOrders
                })
            }).catch(error => {
                this.props.alert("error", this.props.returnLocalizedString("m0023"), this.props.returnLocalizedString("m0025"))
            })
        }

    }

    handleSubmit = () => {
        // do a post to /api/portal/admin/org/CreateOrg, OR /api/portal/admin/org/UpdateOrg

        let apiUrl = '';

        // "m0032" or "m0033" for "updated" and "created"
        let action = '';

        // validation
        // required fields: org name, org type, country, state, language, currency 
        const { orgName, orgType, country, vendor, parentOrgs, inactive, address1, address2, city, state, postalZip, phone, email, fax, website, contactInfo, timeZoneName, language, currency, notes, orgNumber, allowEditSuggestedOrders } = this.state;

        let errorMessage = '';
        if (isEmpty(orgName)) {
            errorMessage = this.props.returnLocalizedString("m0026");
        }
        else if (isEmpty(orgType)) {
            errorMessage = this.props.returnLocalizedString("m0027");
        }
        else if (isEmpty(country)) {
            errorMessage = this.props.returnLocalizedString("m0028");
        }
        else if (isEmpty(state)) {
            errorMessage = this.props.returnLocalizedString("m0029");
        }
        else if (isEmpty(language)) {
            errorMessage = this.props.returnLocalizedString("m0030");
        }
        else if (isEmpty(currency)) {
            errorMessage = this.props.returnLocalizedString("m0031");
        }

        if (!isEmpty(errorMessage)) {
            this.props.alert('error', this.props.returnLocalizedString("m0023"), errorMessage);
            return;
        }

        // grab an array of parent orgIDs
        let parentOrgIDs;
        if (!isEmpty(parentOrgs)) {
            parentOrgIDs = parentOrgs.map(org => org.orgID)
        }

        const payload = {
            orgName,
            orgTypeID: orgType.orgTypeID,
            countryID: country.countryID,
            parentOrgIDs: isEmpty(parentOrgs) ? null : parentOrgIDs,
            vendorID: isEmpty(vendor) ? null : vendor.vendorID,
            address1,
            address2,
            city,
            stateID: isEmpty(state) ? null : state.stateID,
            postalZip,
            phone,
            email,
            fax,
            website,
            contactInfo,
            timeZoneName,
            languageID: isEmpty(language) ? null : language.languageID,
            currencyID: isEmpty(currency) ? null : currency.currencyID,
            notes,
            orgNumber,
            allowEditSuggestedOrders
        }

        // if we're updating an org, then pass in a few additional parameters
        if (!isEmpty(this.props.org)) { // updating org
            payload.inactive = inactive;
            payload.orgID = this.props.org.orgID;
            apiUrl = '/api/portal/admin/org/UpdateOrg'
            action = 'm0032'
        } else { // creating org
            apiUrl = '/api/portal/admin/org/CreateOrg'
            action = 'm0033'
        }
        //console.log('submitting this info', JSON.stringify(payload));

        this.props.postData(apiUrl, payload).then(response => {

            this.props.successAlert( "m0035", action);

            if (isEmpty(this.props.org)) {
                this.setState({
                    hasCreatedOrg: true,

                    // if creating a new org, then retrieve the org code at the end of it all
                    orgCode: response.data.orgCode
                }, () => {
                    this.props.handleRefreshListing();
                })
            } else {
                this.props.handleRefreshListing();
            }



        }).catch(error => {

            //console.log('create/update org error: ', error.message)
            this.props.alert("error", this.props.returnLocalizedString("m0034", action), `${error.response.data}`);
        })


    }


    handleChange = (e) => {

        if (["inactive", "allowEditSuggestedOrders"].includes(e.target.name)) {
            this.setState({
                [e.target.name]: e.target.checked
            })
        }

        else if (e.target.name === "orgType") {

            const orgType = e.target.value;
            //debugger;
            // if we deselected the org type, OR we have picked an org type that is NOT manufacturer or manufacturer region, then we need to clear out the selected vendor
            if (!orgType || ![orgTypes.manufacturerID, orgTypes.manufacturerRegionID].includes(orgType.orgTypeID)) {
                //console.log([orgTypes.manufacturerID, orgTypes.manufacturerRegionID], orgType.orgTypeID);
                this.setState({
                    orgType,
                    vendor: null,
                    parentOrgs: []
                })
            } else {
                this.setState({
                    orgType,
                    parentOrgs: []
                })
            }


        }
        else if (e.target.name === "country") {
            // reset the chosen state
            this.setState({
                country: e.target.value,
                state: null
            })
        }
        else {
            this.setState({
                [e.target.name]: e.target.value
            });
        }

    }
    handleParentOrgChange = (e) => {
        //console.log(this.state.parentOrgs);
        //console.log(e);
        if (e.target.value)
            this.setState({
                parentOrgs: [...e.target.value]
            })
    }

    //!DBTRANS! @m0023@ Error! !DEVNOTE! Action status message
    //!DBTRANS! @m0025@ Unable to fetch details for this org. Please try again. !DEVNOTE! Form submission error message
    //!DBTRANS! @m0026@ You must set an organization name. !DEVNOTE! Form submission error message
    //!DBTRANS! @m0027@ You must select an organization type. !DEVNOTE! Form submission error message
    //!DBTRANS! @m0028@ You must select a country. !DEVNOTE! Form submission error message
    //!DBTRANS! @m0029@ You must select a state. !DEVNOTE! Form submission error message
    //!DBTRANS! @m0030@ You must set a language. !DEVNOTE! Form submission error message
    //!DBTRANS! @m0031@ You must set a currency. !DEVNOTE! Form submission error message
    //!DBTRANS! @m0032@ updated! !DEVNOTE! Submitted Form Type
    //!DBTRANS! @m0033@ created! !DEVNOTE! Submitted Form Type
    //!DBTRANS! @m0034@ The org could not be %action%.!DEVNOTE! Form submission status message
    //!DBTRANS! @m0035@ The org was %action%! !DEVNOTE! Form submission status message
    //!DBTRANS! @m0036@ Success! !DEVNOTE! Action status message
    //!DBTRANS! @m0037@ Organization Type:* !DEVNOTE! Org Form Field
    //!DBTRANS! @m0038@ Vendor: !DEVNOTE! Org Form Field
    //!DBTRANS! @m0039@ Parent Org(s): !DEVNOTE! Org Form Field
    //!DBTRANS! @m0040@ Inactive: !DEVNOTE!Org Form Field
    //!DBTRANS! @m0041@ Allow suggested orders to be edited: !DEVNOTE! Org Form Field
    //!DBTRANS! @m0042@ State:* !DEVNOTE! Org Form Field
    //!DBTRANS! @m0043@ Country:* !DEVNOTE! Org Form Field
    //!DBTRANS! @m0044@ Time Zone: !DEVNOTE! Org Form Field
    //!DBTRANS! @m0045@ Language:* !DEVNOTE! Org Form Field
    //!DBTRANS! @m0046@ Currency:* !DEVNOTE! Org Form Field
    //!DBTRANS! @m0047@ Organization Name !DEVNOTE! Org Form Field
    //!DBTRANS! @m0048@ Org Code !DEVNOTE! Org Form Field
    //!DBTRANS! @m0049@ Org Number !DEVNOTE! Org Form Field
    //!DBTRANS! @m0050@ Notes !DEVNOTE! Org Form Field
    //!DBTRANS! @m0051@ Address (Line 1) !DEVNOTE! Org Form Field
    //!DBTRANS! @m0052@ Address (Line 2) !DEVNOTE! Org Form Field
    //!DBTRANS! @m0053@ City !DEVNOTE! Org Form Field
    //!DBTRANS! @m0054@ Postal Zip !DEVNOTE! Org Form Field
    //!DBTRANS! @m0055@ Phone !DEVNOTE! Org Form Field
    //!DBTRANS! @m0056@ Email !DEVNOTE! Org Form Field
    //!DBTRANS! @m0057@ Fax !DEVNOTE! Org Form Field
    //!DBTRANS! @m0058@ Website !DEVNOTE! Org Form Field
    //!DBTRANS! @m0059@ Contact Info !DEVNOTE! Org Form Field
    //!DBTRANS! @m0060@ Modify Org !DEVNOTE! Org Form Field
    //!DBTRANS! @m0061@ Create Org !DEVNOTE! Org Form Field
    //!DBTRANS! @m0062@ General Org Configuration !DEVNOTE! Org Form Field
    //!DBTRANS! @m0063@ Address !DEVNOTE! Org Form Field
    //!DBTRANS! @m0064@ Contact Information !DEVNOTE! Org Form Field
    //!DBTRANS! @m0065@ Localization !DEVNOTE! Org Form Field

    render() {

        const org = this.props.org;

        // show vendor dropdown only if org type is manufacturer or manufacturer region
        let showVendorField = false;

        // if we have chosen an org type, then show the vendor dropdown *if* the org type is either manufacturer or manufacturer region
        if (this.state.orgType) {
            showVendorField = [orgTypes.manufacturerID, orgTypes.manufacturerRegionID].includes(this.state.orgType.orgTypeID);
        }


        return (
            <div className="position-relative">
                <div className="k-window-title k-dialog-title ">
                    {org ? this.props.returnLocalizedString("m0060") : this.props.returnLocalizedString("m0061")}
                </div>
                <Toolbar onEditScrtooltip={true} >
                    {!this.state.hasCreatedOrg && <ToolbarOption onEditScrtooltip={true} type="save" handleClick={this.handleSubmit} />}

                    <ToolbarOption onEditScrtooltip={true} type="close" handleClick={this.props.handleCloseModal} />
                </Toolbar>

                <div className="grid">
                    <div className="grid-row">
                        <div className="grid-col m-col-12 d-col-6 padding-left-0"  >
                            <FormSection heading= {this.props.returnLocalizedString("m0062")}>
                                <TextField name="orgName" label={this.props.returnLocalizedString("m0047")} value={this.state.orgName} handleChange={this.handleChange} required={true} />

                                {!isEmpty(this.state.orgCode) && (
                                    <TextField name="orgCode" label={this.props.returnLocalizedString("m0048")} value={this.state.orgCode} readonly={true} />
                                )}


                                <TextField name="orgNumber" label={this.props.returnLocalizedString("m0049")} value={this.state.orgNumber} handleChange={this.handleChange} />

                                <div className="bottom-margin-20">
                                    <label htmlFor="orgType">{this.props.returnLocalizedString("m0037")}</label>
                                    <DropDownContainer value={this.state.orgType} required={true}
                                        uiLanguage={this.props.getLanguage()}
                                        handleChange={this.handleChange} dataType="orgTypes" id="orgType" name="orgType" />
                                </div>

                                {
                                    showVendorField && (
                                        <div className="bottom-margin-20">
                                            <label htmlFor="vendor">{this.props.returnLocalizedString("m0038")}</label>
                                            <DropDownContainer value={this.state.vendor}
                                                uiLanguage={this.props.getLanguage()}
                                                handleChange={this.handleChange} dataType="adminVendors" id="vendor" name="vendor" />
                                        </div>)
                                }

                                {
                                    this.state.orgType && (
                                        <div className="bottom-margin-20">
                                            <label htmlFor="parentOrgs">{this.props.returnLocalizedString("m0039")}</label>
                                            <DropDownContainer style={{ "width": "100%" }} excludedOrgIDs={org ? org.orgID : ""} minOrgTypeID={this.state.orgType.orgTypeID} filterable={true} value={this.state.parentOrgs} mode="multiselect"
                                                uiLanguage={this.props.getLanguage()}
                                                handleChange={this.handleParentOrgChange} dataType="allOrgs" id="parentOrgs" name="parentOrgs" />
                                        </div>
                                    )
                                }


                                {
                                    // we only show Inactive checkbox for existing orgs
                                    this.props.org && (
                                        <div className="bottom-margin-20">
                                            <label htmlFor="isInactive">{this.props.returnLocalizedString("m0040")}</label>
                                            <input
                                                id="inactive"
                                                name="inactive"
                                                type="checkbox"
                                                checked={this.state.inactive === true}
                                                onChange={this.handleChange} />
                                        </div>
                                    )}

                                <TextAreaField name="notes" label={this.props.returnLocalizedString("m0050")} value={this.state.notes} handleChange={this.handleChange} />
                                <div className="bottom-margin-20">
                                    <label htmlFor="allowEditSuggestedOrders">{this.props.returnLocalizedString("m0041")}</label>
                                    <input
                                        id="allowEditSuggestedOrders"
                                        name="allowEditSuggestedOrders"
                                        type="checkbox"
                                        checked={this.state.allowEditSuggestedOrders === true}
                                        onChange={this.handleChange} />
                                </div>

                            </FormSection>

                            <FormSection heading= {this.props.returnLocalizedString("m0063")}>

                                <TextField name="address1" label={this.props.returnLocalizedString("m0051")} value={this.state.address1} handleChange={this.handleChange} />

                                <TextField name="address2" label={this.props.returnLocalizedString("m0052")} value={this.state.address2} handleChange={this.handleChange} />

                                <TextField name="city" label={this.props.returnLocalizedString("m0053")} value={this.state.city} handleChange={this.handleChange} />

                                {this.state.country && (
                                    <div className="bottom-margin-20">
                                        <label htmlFor="state">{this.props.returnLocalizedString("m0042")}</label>
                                        <DropDownContainer value={this.state.state}
                                            uiLanguage={this.props.getLanguage()}
                                            handleChange={this.handleChange} dataType="states" countryID={this.state.country.countryID} id="state" name="state" required={true} />
                                    </div>
                                )}
                                <div className="bottom-margin-20">
                                    <label htmlFor="country" >{this.props.returnLocalizedString("m0043")}</label>
                                    <DropDownContainer required={true} value={this.state.country}
                                        uiLanguage={this.props.getLanguage()}
                                        handleChange={this.handleChange} dataType="countries" id="country" name="country" />
                                </div>


                                <TextField name="postalZip" label={this.props.returnLocalizedString("m0054")} value={this.state.postalZip} handleChange={this.handleChange} />
                            </FormSection>
                        </div>
                        <div className="grid-col m-col-12 d-col-6 padding-right-0">

                            <FormSection heading={this.props.returnLocalizedString("m0064")}>

                                {/* 
                                How to do this? Use Kendo React's MaskedInput component
                                https://www.telerik.com/kendo-react-ui/components/inputs/maskedtextbox/

                                Build library of different phone number fields:
                                Canada - +1 604 123 4567
                                USA - +1 604 123 4567
                                Australia - +61 91 1234 1234
                                Mexico - +52 55 12345678
                                New Zealand - +64 1 234 5678
                                China - +86 123 1234 1234
                                Ukraine + 380 122344332
                                India - +91 9779972233

                            */}
                                <TextField name="phone" label={this.props.returnLocalizedString("m0055")} value={this.state.phone} handleChange={this.handleChange} />
                                <TextField name="email" label={this.props.returnLocalizedString("m0056")} value={this.state.email} handleChange={this.handleChange} />
                                <TextField name="fax" label={this.props.returnLocalizedString("m0057")} value={this.state.fax} handleChange={this.handleChange} />
                                <TextField name="website" label={this.props.returnLocalizedString("m0058")} value={this.state.website} handleChange={this.handleChange} />
                                <TextAreaField name="contactInfo" label={this.props.returnLocalizedString("m0059")} value={this.state.contactInfo} handleChange={this.handleChange} />
                            </FormSection>

                            <FormSection heading={this.props.returnLocalizedString("m0065")}>
                                <div className="bottom-margin-20">
                                    <label htmlFor="timeZoneName">{this.props.returnLocalizedString("m0044")}</label>
                                    <DropDownContainer value={this.state.timeZoneName}
                                        uiLanguage={this.props.getLanguage()}
                                        handleChange={this.handleChange} dataType="timeZones" id="timeZoneName" name="timeZoneName" />
                                </div>
                                {/* <TextField name="timeZoneName" label="Time Zone Name" value={this.state.timeZoneName} handleChange={this.handleChange} /> */}
                                <div className="bottom-margin-20">
                                    <label htmlFor="language">{this.props.returnLocalizedString("m0045")}</label>
                                    <DropDownContainer value={this.state.language}
                                        uiLanguage={this.props.getLanguage()}
                                        handleChange={this.handleChange} dataType="languages" id="language" name="language" required={true} />
                                </div>
                                <div className="bottom-margin-20">
                                    <label htmlFor="currency">{this.props.returnLocalizedString("m0046")}</label>
                                    <DropDownContainer value={this.state.currency}
                                        uiLanguage={this.props.getLanguage()}
                                        handleChange={this.handleChange} dataType="currencies" id="currency" name="currency" required={true} />
                                </div>
                            </FormSection>

                        </div>
                    </div>
                </div>



            </div>
        )
    }
}

export default isPage(AdminEditOrgPage);

const TextField = ({ name, label, value, handleChange, required = false }) => {
    return (
        <FormItem>
            <label htmlFor={name}>{label}:{required ? '*' : ''} </label>
            <Input placeholder={label} id={name} required={required} value={value} onChange={handleChange} name={name} type="text" />
        </FormItem>
    )
}

const TextAreaField = ({ name, label, value, handleChange, required = false }) => {
    return (
        <FormItem>
            <label htmlFor={name}>{label}:{required ? '*' : ''} </label>
            <textarea style={{ width: '100%' }} className="k-textarea" id={name} required={required} onChange={handleChange} name={name} value={value} />
        </FormItem>
    )
}



// WEBPACK FOOTER //
// ./src/containers/AdminEditOrgPage.js